import {Context, EMPTY_CONTEXT, Options, Schema} from './schema';

export interface StringOptions extends Options<string | null> {
  minLength?: number | ((context?: Context) => number | null);
  maxLength?: number | ((context?: Context) => number | null);
}

export class StringSchema extends Schema<string | null, StringOptions> {
  constructor(options: StringOptions = {}) {
    super(options);
  }

  public toJSON(): object {
    return {
      type: 'StringSchema',
      ...super.toJSON(),
      minLength: this._options.minLength,
      maxLength: this._options.maxLength,
    };
  }

  public minLength(context: Context = EMPTY_CONTEXT): number | null {
    return this._options.minLength === undefined
      ? null
      : typeof this._options.minLength === 'function'
        ? this._options.minLength(context)
        : this._options.minLength;
  }

  public maxLength(context: Context = EMPTY_CONTEXT): number | null {
    return this._options.maxLength === undefined
      ? null
      : typeof this._options.maxLength === 'function'
        ? this._options.maxLength(context)
        : this._options.maxLength;
  }

  public valueToMobx(value: string | null): string | null {
    return this._nullifyValue(value);
  }

  public valueToJS(
    value: string | null,
    context: Context = EMPTY_CONTEXT,
  ): string | null {
    return this.isComputed
      ? this.computedValue(context)
      : this._nullifyValue(value);
  }

  public typeIsValid(value: any): value is string | null {
    return value === null || typeof value === 'string';
  }

  public valueIsValid(
    value: string | null,
    context: Context = EMPTY_CONTEXT,
  ): boolean {
    return (
      this.requiredIsValid(value, context) &&
      this.minLengthIsValid(value, context) &&
      this.maxLengthIsValid(value, context) &&
      this.customFunctionIsValid(value, context)
    );
  }

  public minLengthIsValid(
    value: string | null,
    context: Context = EMPTY_CONTEXT,
  ): boolean {
    const minLength = this.minLength(context);
    return value === null || minLength === null || value.length >= minLength;
  }

  public maxLengthIsValid(
    value: string | null,
    context: Context = EMPTY_CONTEXT,
  ): boolean {
    const maxLength = this.maxLength(context);
    return value === null || maxLength === null || value.length <= maxLength;
  }
}
